export class InviteMemberFlowError extends Error {
  readonly name = 'InviteMemberFlowError'

  constructor(
    message: string,
    readonly closeDialog: boolean
  ) {
    super(message)
  }

  static closeAfterToast(message: string): InviteMemberFlowError {
    return new InviteMemberFlowError(message, true)
  }

  static stayOpen(message: string): InviteMemberFlowError {
    return new InviteMemberFlowError(message, false)
  }
}
